import { getProfile } from '../../config/activityProfileConfig2';
import useGrandeEcole from '../../stores/useGrandeEcole';
import ModuleRenderer from './ModuleRenderer';

export default function AppMain({ 
  activeSection, 
  darkMode = true,
  isEditing, 
  handleSaveSection, 
  toggleEdit 
}) {
  const {
    loading,
    totalLearners,
    activeLearners,
    totalPesasCirculating,
    globalCompletionRate,
    criticalAlerts,
    learners,
    courses,
    cohortes,
    staff,
    activityProfile,
    profile: storeProfile,
    layout,
  } = useGrandeEcole();

  const profile = getProfile(activityProfile);
  const activeModule = layout?.modules?.[activeSection];
  const label = activeModule?.label ?? activeSection;

  return (
    <div className="space-y-6">
      {/* En-tête de section */}
      <div className="pb-4 border-b border-orange-900/30">
        <div className="flex flex-col md:flex-row md:items-baseline gap-2 md:gap-4">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-black tracking-tight text-orange-300/90">
            {label}
          </h2>
          <code className="text-xs text-zinc-500 bg-black/40 px-2 py-0.5 rounded border border-zinc-800 self-start">
            /{activeSection}
          </code>
        </div>
        <div className="mt-1.5 text-[10px] md:text-xs uppercase tracking-wider opacity-60 flex items-center gap-3 flex-wrap">
          <span>INTERFACE DE CONTRÔLE EN TEMPS RÉEL</span>
          <span>•</span>
          <span>{new Date().toLocaleTimeString('fr-FR')}</span>
          {loading && (
            <>
              <span>•</span>
              <span className="text-amber-400">SYNC...</span>
            </>
          )}
        </div>
      </div>

      {/* Rendu du module actif avec toutes les données */}
      <div className="mt-6">
        <ModuleRenderer 
          sectionId={activeSection}
          profile={profile}
          layout={layout}
          darkMode={darkMode}
          totalLearners={totalLearners}
          activeLearners={activeLearners}
          totalPesasCirculating={totalPesasCirculating}
          globalCompletionRate={globalCompletionRate}
          criticalAlerts={criticalAlerts}
          learners={learners}
          courses={courses}
          cohortes={cohortes}
          staff={staff}
          isEditing={isEditing}
          handleSaveSection={handleSaveSection}
          toggleEdit={toggleEdit}
          activityProfile={activityProfile}
        />
      </div>

      {/* Footer système */}
      <div className="mt-16 pt-6 border-t border-zinc-800 text-[10px] md:text-xs opacity-40 flex flex-col md:flex-row justify-between gap-2 uppercase tracking-widest pb-6">
        <div className="flex flex-wrap items-center gap-4">
          <span>ÉTAT MOTEUR • 92.4 %</span>
          <span>TEMP. CŒUR • 41.2 °C</span>
          <span className="text-emerald-400">
            {totalLearners} USERS • {(totalPesasCirculating / 1000000).toFixed(2)}M₧
          </span>
        </div>
        <div>GRANDE ÉCOLE • PILOTAGE 2026</div>
      </div>
    </div>
  );
}